import { fillString } from '@local_modules/generic/string-template.js'
import { generateRandomString } from '@local_modules/generic/text/generate-random-string/index.js'
import { setElementHtml } from '@local_modules/generic/dom/set-element-html.js'

import htmlTemplateIndex from './index.html'

import { checkPageRestriction } from '../../../helpers/restrictions/check-page-restriction.js'
import { applyHtmlRestrictions } from '../../../helpers/restrictions/apply-html-restrictions.js'
import { addListeners } from './listeners.js'
import { showUserToken } from './user-token/user-token.js'
import { showConnectionSuccess } from './connection-success/show-connection-success.js'
import { showAssociatedEntities } from './associated-entities/show-associated-entities.js'

/**
 *
 * @returns
 */
export async function showPageConnectXero (params) {
  console.log('showPageConnectXero', params)

  const { containerElementId, browserAppUser, browserAppAccount } = params

  if (!checkPageRestriction({ browserAppUser, browserAppAccount })) return

  // Prepare the html
  let htmlIndex = htmlTemplateIndex

  htmlIndex = applyHtmlRestrictions(htmlIndex, { browserAppAccount, browserAppUser })
  const elementId = 'i' + generateRandomString()
  htmlIndex = fillString(htmlIndex, { elementId })

  // Inject in the page
  const containerElement = setElementHtml(containerElementId, htmlIndex)

  // Set page title
  document.title = ['Connect Xero:', browserAppAccount.data.appAccount.name].join(' ')

  // Set full height
  document.getElementById(containerElementId)?.classList.add('position-absolute')
  document.getElementById(containerElementId)?.classList.add('top-to-bottom')

  addListeners(containerElement)

  showConnectionSuccess({
    containerElementId: 'connectionSuccess',
    newXeroConnection: params.newXeroConnection
  })

  showUserToken({
    containerElementId: 'userTokenTenants',
    browserAppUser,
    browserAppAccount
  })

  showAssociatedEntities({
    containerElementId: 'associatedEntities',
    browserAppAccount
  })
}
